<script setup lang="ts">
import { DateTime } from "luxon";
import { SearchType } from "../../../types/tabs";
import { useI18n } from "vue-i18n";

interface Props {
  searchType: SearchType;
  departureLocationName?: string;
  arrivalLocationName?: string;
  departureDate?: Date;
  returnDate?: Date;
  numberOfGuests: number;
  numberOfRooms: number;
  numberOfNights: number;
}

const props = defineProps<Props>();

const emit = defineEmits<(e: "modify") => void>();

function clickModify() {
  emit("modify");
}

const iconMap: Partial<Record<SearchType, string>> = {
  [SearchType.Package]: "fa-suitcase",
  [SearchType.FlightAndHotel]: "fa-suitcase",
  [SearchType.Hotels]: "fa-hotel",
};

const iconClass = iconMap[props.searchType] ?? "";

const dateFormat = "dd MMM";
const { locale } = useI18n();

const departureDateFormatted = props.departureDate
  ? DateTime.fromJSDate(props.departureDate)
      .setLocale(locale.value)
      .toFormat(dateFormat)
  : "";
const returnDateFormatted = props.returnDate
  ? DateTime.fromJSDate(props.returnDate)
      .setLocale(locale.value)
      .toFormat(dateFormat)
  : "";
</script>

<template>
  <div class="vacv-form-row vacv-input wide-5-items" :class="searchType">
    <div class="vacv-form-item type" data-test="search-type">
      <i class="fa-solid" :class="iconClass" aria-hidden="true"></i>
      {{ $t("form.searchTypes." + searchType) }}
    </div>
    <div class="vacv-form-item location" data-test="location-names">
      {{ searchType !== SearchType.Hotels ? departureLocationName + " -" : "" }}
      {{ arrivalLocationName }}
    </div>
    <div class="vacv-form-item dates" data-test="dates-formatted">
      <i class="fa-solid fa-calendar-days"></i>
      {{ departureDateFormatted }} - {{ returnDateFormatted }} ({{
        numberOfNights
      }}
      {{ $t("nights") }})
    </div>
    <div class="vacv-form-item guests-rooms" data-test="guests-rooms">
      <span class="guests">
        <i class="fa-solid fa-user" aria-hidden="true"></i>
        {{ numberOfGuests }}
      </span>
      <span class="rooms">
        <i class="fa-solid fa-bed" aria-hidden="true"></i>
        {{ numberOfRooms }}
      </span>
    </div>
    <div class="vacv-form-item submit">
      <button type="button" class="vacv-btn-secondary" @click="clickModify">
        {{ $t("form.modify") }}
      </button>
    </div>
  </div>
</template>
